import type { ReactNode } from 'react';
import { Toaster } from 'react-hot-toast';
import { SupportWidget } from './components/support/SupportWidget';
import ErrorBoundary from './components/ErrorBoundary';
import './i18n/config';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from './store/auth.store';
import { toHtmlLang } from './utils/htmlLang';

export function AppView({ routerNode }: { routerNode: ReactNode }) {
  const logout = useAuthStore((state) => state.logout);

  useEffect(() => {
    const handleLogout = () => {
      logout();
    };

    globalThis.addEventListener('auth:logout', handleLogout);
    return () => globalThis.removeEventListener('auth:logout', handleLogout);
  }, [logout]);

  const { i18n } = useTranslation();

  useEffect(() => {
    const isRtl = ['ar', 'darija_ar'].includes(i18n.language) || i18n.dir(i18n.language) === 'rtl';
    const dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = toHtmlLang(i18n.language);
  }, [i18n.language]);

  return (
    <ErrorBoundary>
      {routerNode}
      <SupportWidget />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#4ade80',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </ErrorBoundary>
  );
}

export default AppView;
